

Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.MappingScreenPlanText = (function () {

    function MappingScreenPlanText(preview) {

        this.className ='MappingScreenPlanText';

        this.type = 'text';
        this.title = 'Greenmile.DataImport.MappingScreenPlanText.title';

        Greenmile.DataImport.MappingScreen.apply(this, arguments);

        this.renderPreview = function() {

            var searchContainer = document.createElement('div'),
                label = document.createElement('label'),
                content = document.createElement('div'),
                offsetLengthSample = document.createElement('div'),
                addLineButton = document.createElement('div'),
                setOffsetLengthSample,
                previewValue = preview.firstLine[0][0],
                offsetSelection = ' ',
                lengthSelectionValue = ' ',
                selectedText = '';

            setOffsetLengthSample = function() {
                var selection = window.getSelection();

                selectedText = selection.toString();

                if (selectedText) {

                    if(selection.focusOffset < selection.baseOffset) {
                        offsetSelection = selection.focusOffset + 1;
                        lengthSelectionValue = Math.abs(selection.baseOffset + 1 - offsetSelection);
                    } else {
                        offsetSelection = selection.baseOffset + 1;
                        lengthSelectionValue = Math.abs(selection.focusOffset + 1 - offsetSelection);
                    }
                } else {
                    offsetSelection = ' ';
                    lengthSelectionValue = ' ';
                }

                offsetLengthSample.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.DataImport.offset', offsetSelection) + ' - ' +
                                                Monet.I18n.getResourcesByKey('Greenmile.DataImport.length', lengthSelectionValue);
            };

            var addLineFunction = function() {
                if ( selectedText ) {
                    this.table.addNewLine(null, selectedText, offsetSelection, lengthSelectionValue);
                    setOffsetLengthSample();
                }

            }.bind(this);

            searchContainer.className = 'previewContainer';
            label.className = 'previewLabel';
            addLineButton.className = 'addLineButton gmfont icon-fill-row';
            content.className = 'previewContent';
            offsetLengthSample.className = 'offsetLengthSample';

            label.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.DataImport.txtPreviewLabel');
            content.innerHTML = previewValue;
            searchContainer.appendChild(label);
            searchContainer.appendChild(content);
            searchContainer.appendChild(addLineButton);
            searchContainer.appendChild(offsetLengthSample);

            setOffsetLengthSample();

            content.addEventListener('mouseup',setOffsetLengthSample);
            addLineButton.addEventListener('click',addLineFunction);

            return searchContainer;
        };

        this.validate = function() {

            Greenmile.DataImport.Utils.clearErrorMessage();

            var result = { errorMessages:[] },
                values = this.getValue(),
                status = true;

            if ( !values.name ) {
                result.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject('Greenmile.DataImport.layoutNameIsMandatory'));
                status =  false;
            }

            var columnsWithoutPath = [];
            for ( var i = 0, length=values.columns.length; i < length; i++ ) {
                var column = values.columns[i],
                    hasFileFieldMapped = column.offsetStart && column.offsetLength;

                if ( !column.fieldPath && (!hasFileFieldMapped || !column.defaultValue) ) {
                    result.errorMessages.push(
                        Monet.Form.Messages.mountErrorMessageObject(
                            Monet.I18n.getResourcesByKey('Greenmile.DataImport.pathNotFound', column.fileColumnName)));
                    columnsWithoutPath.push(column);
                    status =  false;
                }

                if ( column.offsetStart && column.offsetLength && column.fieldPath && column.defaultValue ) {
                    result.errorMessages.push(
                        Monet.Form.Messages.mountErrorMessageObject(
                            Monet.I18n.getResourcesByKey('Greenmile.DataImport.selectColumnNumOrDefault', column.fileColumnName))
                    );
                    columnsWithoutPath.push(column);
                    status =  false;
                }
            }

            if(result.errorMessages.length === 1) {
                result.errorMessage = result.errorMessages[0];
                delete result.errorMessages;
            }

            result.value = values;
            result.status = status;

            return result;

        }.bind(this);

        this.getTxtColumnsValue = function() {
            var lines = this.table.table.childNodes;
            var columns = [];

            for (var i = 1; i< lines.length; i++) {
                var line = lines[i],
                    offset = parseInt(line.querySelector('.container-numbers .offset').value) || undefined,
                    length = parseInt(line.querySelector('.container-numbers .length').value) || undefined,
                    objToReturn = this.table.getFixedValuesByLine(line);

                objToReturn.offsetStart = offset;
                objToReturn.offsetLength = length;
                columns.push(objToReturn);
            }

            return columns;

        }.bind(this);

        this.setLinesValue = function() {
            var columns = this.layout.columns,
                model = null,
                line = null;

            for (var i = 0, length = columns.length; i < length; i++) {
                model = columns[i];

                line = this.addNewLine(model,  null, model.offsetStart, model.offsetLength);

                model.path = model.fieldPath;
                model.label = this.gmFieldList[model.fieldPath].label;
                model.type = this.gmFieldList[model.fieldPath].type;

                this.setFixedColumnsValue(line, model);
                this.selectGMFieldValue(model, line.querySelector('.gm  span.value'));
            }
        };

        this.getValue = function() {
            var name = this.layoutName.getValue(),
                data = {};

            data.name = name;
            data.fileType = this.type.toUpperCase();
            data.rootEntity = App.Forms.DataImport.EntityList.getSelected();

            data.columns = this.getTxtColumnsValue();
            data.configuration = this.advancedConfigs.getValue();
            if (this.value && this.value.id) {
                data.id = this.value.id;
            }

            return data;
        };

    }

    return MappingScreenPlanText;
}());